import TeamTimeSheet from 'components/TeamTimeSheet';
  
  const UpdateTeamTimeSheet = () => {
    
    return (
        <TeamTimeSheet/>
    );
  };
  
  export default UpdateTeamTimeSheet;
  